import classes from './DisplayException.module.css'

function DisplayException(props){
    return(<>
        <div className={classes.container}>
            <div className={classes.errorMessage}>
                <p style={{fontWeight:'bold', color:'black'}} > {props.children} <br/></p>
                <p> Try reloading the app. If the problem persists, please contact <span style={{color:'var(--aixelo-blue)'}}>helpdesk@aixelo.com</span> </p>
            </div>
        </div>
    </>);

}


export default DisplayException;
